// extracted by mini-css-extract-plugin
export var fullGrid = "_37-3";
export var pdpPreviewContainer = "_37-1";
export var previewContainer = "_37-0";
export var togglePreviewContainer = "_37-2";